import Spinner from '../../../../../ui/Spinner/Spinner';
import { useTheme } from '../../../../../../hooks/useTheme';

export function CoverLoading() {
  const theme = useTheme();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 200,
      }}
    >
      <Spinner
        s={{
          width: 32,
          height: 32,
          color: theme.iconsPrimaryNone?.color,
        }}
      />
    </div>
  );
}
